import { Paper as NovaPaper, PaperProps as NovaPaperProps } from '@fme-nova/components'
import { default as MuiPaper, PaperProps as MuiPaperProps } from '@mui/material/Paper'

import { createComponentWrapperWithRef } from '../../theme'

export const Paper = createComponentWrapperWithRef<MuiPaperProps | NovaPaperProps>(
  {
    mui: MuiPaper,
    nova: NovaPaper,
  },
  'Paper',
)
